module.exports = __webpack_public_path__ + "images/igglo-logo.1a9ec9cf81c49404dc1f777f5873f32e.svg";